(() => {
  if (window.__nsHeroParallaxBound) return;
  window.__nsHeroParallaxBound = true;

  const selector = '[data-ns-hero-parallax]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let animationFrame = 0;

  const update = () => {
    animationFrame = 0;
    const enabled = window.innerWidth < 750 && !reducedMotion.matches;

    document.querySelectorAll(selector).forEach((hero) => {
      if (!enabled) {
        hero.style.removeProperty('--ns-hero-yacht-shift');
        return;
      }

      const yacht = hero.querySelector('.ns-hero__mobile-yacht');
      if (!yacht) return;

      const maximumScroll = hero.offsetHeight * 0.72;
      const heroScroll = Math.min(Math.max(window.scrollY, 0), maximumScroll);
      const availableRightOverflow = Math.max(
        yacht.offsetLeft + yacht.offsetWidth - hero.clientWidth,
        0,
      );
      const shift = Math.min(heroScroll * 0.12, availableRightOverflow) * -1;
      hero.style.setProperty('--ns-hero-yacht-shift', `${shift.toFixed(3)}px`);
    });
  };

  const scheduleUpdate = () => {
    if (animationFrame) return;
    animationFrame = window.requestAnimationFrame(update);
  };

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate, { passive: true });
  reducedMotion.addEventListener('change', scheduleUpdate);
  document.addEventListener('shopify:section:load', scheduleUpdate);
  scheduleUpdate();
})();
